import { TranslateHelper } from '@app/_helpers';
import { Component, Input } from '@angular/core';
import { RootService } from '@services/root.service';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { CollapseDirective, CollapseItemDirective } from '../../shared/directives/collapse.directive';

@Component({
    selector: 'app-widget-categories',
    templateUrl: './widget-categories.component.html',
    styleUrls: ['./widget-categories.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [CollapseDirective, NgFor, CollapseItemDirective, NgIf, RouterLink, IconComponent, TranslateModule]
})
export class WidgetCategoriesComponent {
    @Input() location: 'blog'|'shop' = 'blog';
    @Input() categories: any[] = [];

    constructor(
        public root: RootService, public translateHelper: TranslateHelper
    ) { }

    sectorSlug(category) {
       return category.sectorData[0]?.seo?.slug;
     }
}
